<template>
  <main class="about">
    <section class="full" :class="{ inverse: sideBarOpen }">
      <div class="br p">
        <blocks v-if="contact.text" :content="JSON.parse(contact.text)" />
      </div>
      <div class="p" @click="sideBarOpen = !sideBarOpen"></div>
    </section>
  </main>
</template>

<script>
import Blocks from "@/components/Blocks.vue";
import { mapState } from "vuex";
export default {
  name: "contact",
  components: {
    Blocks
  },
  metaInfo() {
    return {
      title: "– Contact"
    };
  },
  data() {
    return {
      sideBarOpen: false
    };
  },
  computed: mapState(["contact"])
};
</script>

<style>
.br {
  position: relative;
}
</style>
